<template>
  <div class="main">
    <!-- 上部分 -->
    <div class="title">
      <span class="text">
        会员诉求
        <span>
          (
          <span style="color: #FF0000">*</span>为必填项)
        </span>
      </span>
      <el-button type="primary" class="addButton" @click="add">添加</el-button>
    </div>
    <!-- 下部分 -->
    <!-- 表格 -->
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 99%;height: 530px;overflow-y: scroll;"
        :header-row-style="{color: '#666'}"
      >
        <el-table-column align="center" prop="orderNumber" type="index" :index="increamentIndex" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="companyname" label="会员单位"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="position" label="职务"></el-table-column>
        <el-table-column align="center" prop="title" label="标题"></el-table-column>
        <el-table-column align="center" prop="phone" label="联系电话"></el-table-column>
        <el-table-column align="center" prop="content" label="内容"></el-table-column>
        <el-table-column align="center" prop="reply" label="回复"></el-table-column>
      </el-table>
      <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      id: ''
    }
  },
  mounted () {
    this.asyncGetFeedBackPage()
  },
  methods: {
    // 序号自增
    increamentIndex (index) {
      return index + (this.currentPage - 1) * this.pageSize + 1
    },
    asyncGetFeedBackPage () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.id = resp.data.id
          let _params = {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            membershipid: this.id

          }
          API.getFeedBackPage(_params).then(resp => {
            if (resp.resultCode === '0000') {
              this.tableData = resp.data.list
              this.total = resp.data.total
            }
          })
        }
      })
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.asyncGetFeedBackPage()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.asyncGetFeedBackPage()
    },
    add () {
      this.$router.push('/editAppeal')
    }
  }
}
</script>

<style>

</style>
